import React, { Component, PropTypes } from 'react';
import { FontIcon, IconMenu, IconButton, MenuItem } from 'material-ui';
import R from 'ramda';
import DeleteIcon from 'material-ui/svg-icons/action/delete';
import ReportIcon from 'material-ui/svg-icons/content/flag';
import ProfileIcon from 'material-ui/svg-icons/social/domain';
// import EditIcon from 'material-ui/svg-icons/editor/mode-edit';

class IconCompNameLoc extends Component {
  constructor() {
    super();
    this.state = {
      showSeeMoreLocs: false,
    };
  }

  render() {
    const {
      body,
      compNameDivStyle,
      isOwner,
      displayType,
      changeRoute,
      deleteAPost,
      reportAPost,
    } = this.props;

    const {
      companyName,
      companyId,
      locations,
      sendAsCorporate,
    } = body;

    const compNameStyle = { fontSize: '16px', color: 'rgb(0, 188, 212)' };
    const showLocations = Boolean(locations && !sendAsCorporate);
    const longLocNames = R.pluck('name')(locations).join(', ').length > 40;

    return (
      <div style={{ display: 'flex', flexDirection: 'row', padding: '2% 2% 0 2%' }}>
        <div
          style={R.merge({
            display: 'flex',
            flexDirection: 'column',
            width: displayType ? '100%' : '95%',
            fontFamily: "'Open Sans','Helvetica Neue',Helvetica,Arial,sans-serif",
          }, (compNameDivStyle || {}))}
        >
          <span style={compNameStyle}>
            {companyName}
          </span>
          {
            showLocations &&
            <div>
              <span style={this.state.showSeeMoreLocs ? { overflow: 'visible', maxWidth: '95%' } :
                { float: 'left', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis', maxWidth: '425px', width: '85%' }}
              >
                {locations.map((loc, i) => {
                  return (
                    <FontIcon
                      key={i}
                      onTouchTap={() => changeRoute(`/locations/${loc.locationId}`)}
                      className="tc-icon-location_on"
                      style={{ cursor: 'pointer', fontSize: '12px', color: 'rgba(0, 0, 0, 0.54)', marginRight: '5px' }}
                    >
                      <span style={{ fontFamily: "'Open Sans','Helvetica Neue',Helvetica,Arial,sans-serif" }}>{loc.name}</span>
                    </FontIcon>
                  );
                })}
              </span>
              {
                longLocNames &&
                  <span
                    style={{ fontSize: '10px', color: '#00bcd4', cursor: 'pointer', display: 'flex', float: 'right', lineHeight: '25px' }}
                    onTouchTap={() => this.setState({ showSeeMoreLocs: !this.state.showSeeMoreLocs })}
                  >
                    {this.state.showSeeMoreLocs ? '- See Less' : '+ See More'}
                  </span>
              }
            </div>
          }
        </div>
        <div>
          {
            !displayType &&
            <div style={{ width: '3%' }}>
              <IconMenu
                style={{ padding: 0 }}
                iconButtonElement={<IconButton
                  style={{ height: '100%', padding: 0, width: '100%' }}
                  iconStyle={{ color: 'rgba(0, 0, 0, 0.54)', padding: 0 }}
                  iconClassName="tc-icon-more_horiz"
                />}
                anchorOrigin={{ horizontal: 'left', vertical: 'top' }}
                targetOrigin={{ horizontal: 'left', vertical: 'top' }}
                desktop
              >
                {/*
                 <MenuItem
                 primaryText="Edit"
                 leftIcon={<EditIcon color="rgb(0, 188, 212)" />}
                 />
                 */}
                {!isOwner && (<MenuItem
                  primaryText="Company Profile"
                  leftIcon={<ProfileIcon color="rgb(0, 188, 212)" />}
                  onTouchTap={() => changeRoute(`/company/${companyId}`)}
                />)}
                {isOwner && (<MenuItem
                  primaryText="Delete"
                  leftIcon={<DeleteIcon color="rgb(255, 64, 129)" />}
                  onTouchTap={() => {
                    const confirm = window.confirm('Are you sure you want to delete this post?');
                    if (confirm) {
                      deleteAPost();
                    }
                  }}
                />)}
                {!isOwner &&
                <MenuItem
                  primaryText={R.propOr(false, 'reported', body) ? 'Thanks for reporting!' : 'Report'}
                  leftIcon={<ReportIcon color="rgb(255, 64, 129)" />}
                  onTouchTap={reportAPost}
                  disabled={R.propOr(false, 'reported', body)}
                />}
              </IconMenu>
            </div>
          }
        </div>
      </div>
    );
  }
}

IconCompNameLoc.propTypes = {
  companyName: PropTypes.string,
  companyId: PropTypes.string,
  compNameDivStyle: PropTypes.object,
  locations: PropTypes.array,
  sendAsCorporate: PropTypes.bool,
  displayType: PropTypes.string,
  isOwner: PropTypes.bool,
  deleteAPost: PropTypes.func,
  reportAPost: PropTypes.func,
  changeRoute: PropTypes.func,
  body: PropTypes.object,
};

export default IconCompNameLoc;



// WEBPACK FOOTER //
// ./src/app/components/newsfeed/mainFeed/compNameLoc.jsx